import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "backdrop", "panel"]

  connect() {
    // Listen for turbo frame loads to auto-open modal
    const frame = document.getElementById("modal_frame")
    if (frame && frame.innerHTML.trim()) {
      this.open()
    }

    // Bind and store the frame render handler
    this.boundFrameRender = this.handleFrameRender.bind(this)

    // Listen for turbo frame render events
    document.addEventListener("turbo:frame-render", this.boundFrameRender)
  }

  handleFrameRender(event) {
    const frame = event.target
    if (frame.id === "modal_frame" && frame.innerHTML.trim()) {
      this.open()
    }
  }

  open() {
    // Show the modal
    this.element.classList.remove("hidden")

    // Animate backdrop
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("opacity-0")
      this.backdropTarget.classList.add("opacity-100")
    }

    // Animate panel
    if (this.hasPanelTarget) {
      setTimeout(() => {
        this.panelTarget.classList.remove("opacity-0", "scale-95")
        this.panelTarget.classList.add("opacity-100", "scale-100")
      }, 10)
    }

    // Prevent body scroll
    document.body.style.overflow = "hidden"

    // Add ESC key listener
    this.boundEscapeKey = this.escapeKey.bind(this)
    document.addEventListener("keydown", this.boundEscapeKey)
  }

  close() {
    // Animate panel out
    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("opacity-0", "scale-95")
      this.panelTarget.classList.remove("opacity-100", "scale-100")
    }

    // Animate backdrop out
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("opacity-0")
      this.backdropTarget.classList.remove("opacity-100")
    }

    // Hide modal after animation and clear frame
    setTimeout(() => {
      this.element.classList.add("hidden")
      // Clear the turbo frame content
      const frame = document.getElementById("modal_frame")
      if (frame) {
        frame.innerHTML = ""
      }
    }, 200)

    // Restore body scroll
    document.body.style.overflow = ""

    // Remove ESC key listener
    document.removeEventListener("keydown", this.boundEscapeKey)
  }

  closeBackground(event) {
    // Close if clicked on backdrop
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  escapeKey(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  disconnect() {
    if (this.boundEscapeKey) {
      document.removeEventListener("keydown", this.boundEscapeKey)
    }
    if (this.boundFrameRender) {
      document.removeEventListener("turbo:frame-render", this.boundFrameRender)
    }
    document.body.style.overflow = ""
  }
}